import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ExameSegModal from '../Modals/ExameSegModal';

const ExameSeg = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row-reverse items-center gap-8">
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <img 
              src="/logos/exameseg-color.png" 
              alt="ExameSeg Logo" 
              className="w-full max-w-md mx-auto cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            />
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <h2 className="text-3xl font-bold text-teal-700 mb-4">ExameSeg</h2>
            <p className="text-gray-700 mb-6">
              A ExameSeg é nossa unidade dedicada à realização de exames ocupacionais e complementares. 
              Com equipamentos modernos e equipe médica especializada, garantimos agilidade e precisão 
              nos resultados para sua empresa cumprir todas as exigências legais.
            </p>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
            >
              Conhecer a ExameSeg
            </button>
          </motion.div>
        </div>
      </div>

      <ExameSegModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default ExameSeg;